import queryString from 'query-string';
import { useState } from 'react';
import { withRouter } from 'react-router-dom';

import logo from '../../../assets/images/logos/powertrack.png';
import AlertService from '../../../components/SweetAlert';
import ToastUtil from '../../../components/ToastNotification/ToastUtil';
import { config } from '../../../config/index';
const { API_URL, ASSOCIATE_URL } = config;

const ResetPassword = ({ location, history, match: { params } }) => {
  const token = queryString.parse(location.search).token;
  const type = params.type;

  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const submitHandler = async (e) => {
    e.preventDefault();
    if (
      await AlertService.confirm(
        '',
        'Are you sure you want to reset your password?'
      )
    ) {
      let url = `${API_URL}/${type}/reset-password/change`;
      try {
        let response = await fetch(url, {
          method: 'POST',
          body: JSON.stringify({ password }),
          withCredentials: true,
          mode: 'cors',
          headers: {
            Authorization: token,
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
          },
        });

        let responseData = await response.json();

        if (responseData.success) {
          ToastUtil.success(responseData.message);
          if (type === 'associate') {
            window.location.href = ASSOCIATE_URL;
          } else {
            history.push('/');
          }
        } else {
          ToastUtil.error(responseData.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  return (
    <div
      className="d-flex flex-column text-center align-items-center justify-content-center"
      style={{ height: '100vh' }}
    >
      <div
        className="container"
        style={{ position: 'relative', height: '75%', width: '350px' }}
      >
        <div className="mb-4 pb-2 mx-auto" style={{ width: '200px' }}>
          <img src={logo} style={{ width: '200px' }} alt="" />
        </div>
        <h5>Reset Password</h5>
        <form onSubmit={(e) => submitHandler(e)}>
          <div style={{ position: 'relative' }}>
            <input
              className="form-control mt-4 mb-2"
              type={showPassword ? 'text' : 'password'}
              placeholder="Set Password"
              onChange={(e) => setPassword(e.target.value)}
            />
            <span
              onClick={() => setShowPassword(!showPassword)}
              style={{
                position: 'absolute',
                right: '10px',
                top: '50%',
                transform: 'translateY(-50%)',
                cursor: 'pointer',
                color: '#555',
              }}
            >
              {showPassword ? (
                <i
                  className="far fa-eye-slash"
                  style={{ color: '#888383', fontSize: '14' }}
                ></i>
              ) : (
                <i
                  className="far fa-eye"
                  style={{ color: '#888383', fontSize: '14' }}
                ></i>
              )}
            </span>
          </div>
          <button type="submit" className="btn btn-block btn-brand mt-4">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default withRouter(ResetPassword);
